/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ name: NonNullable<unknown> }} App_Default_TitleInputs */

const cs_app_default_title = /** @type {(inputs: App_Default_TitleInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.name} · Portál makléře`)
};

const en_app_default_title = /** @type {(inputs: App_Default_TitleInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.name} · Agent portal`)
};

/**
* | output |
* | --- |
* | "{name} · Agent portal" |
*
* @param {App_Default_TitleInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const app_default_title = /** @type {((inputs: App_Default_TitleInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<App_Default_TitleInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_app_default_title(inputs)
	return cs_app_default_title(inputs)
});